export default __webpack_public_path__ + "static/media/phase1.e33177b2.svg";